//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import {
  lighten,
  makeStyles,
  withStyles,
  styled,
} from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PhoneIcon from "@material-ui/icons/Phone";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Button from "@material-ui/core/Button";
import ListItemText from "@material-ui/core/ListItemText";
import EjectIcon from "@material-ui/icons/Eject";
import FavoriteIcon from "@material-ui/icons/Favorite";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import HelpIcon from "@material-ui/icons/Help";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";
import ThumbDown from "@material-ui/icons/ThumbDown";
import ThumbUp from "@material-ui/icons/ThumbUp";
import AddIcon from "@material-ui/icons/Add";
import swal from "@sweetalert/with-react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {useTranslation} from 'react-i18next';

//Child Components
import MiddleHeader from "../middleHeader/middleHeader";
import { useParams } from "react-router-dom";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import Spinner from "../../Global/Spinner";
import DarkButton from "../../Global/DarkButton";
import NoRecords from "../../Global/NoRecords";

//Custom Css + Images
import "./templateReportStyle.css";
import pencil from "../../Assets/pencil.png";
import placeholder from "../../Assets/placeholder.jpg";

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Others
import { LazyLoadImage } from 'react-lazy-load-image-component';


const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

function TemplateReportStyle() {
  const { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const [value, setValue] = React.useState(1);
  const [originValue, setOriginValue] = React.useState(1);
  const [selectedTheme, setSelectedTheme] = React.useState(0);
  const [themesArr, setThemesArr] = React.useState([]);
  const [selctedUsers, setSelectedUsers] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [stylesData, setStylesData] = useState([]);
  const [tempLoader, setTempLoader] = useState(false);
  const [rows, setRows] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [currentCompany, setCurrentCompany] = useState({});
  let history = useHistory();
  let { temp_id,  template_name } = useParams();

  const handleCancel = () => {
    getStyles();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let company = useSelector((state) => state.companyReducer.company);

  React.useEffect(
    () => {
      setCurrentCompany(company);
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);
      setCurrentUser(data);
      getTemplates(company);
      getStyles();
    },
    [company?.id]
  );

  const getTemplates = async (currentCompany) => {
    setTempLoader(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    //this.setState({loader:true})
    var params = {
      company_id: currentCompany.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi +
        "/TemplateShare/get_all_template_shares_for_user?" +
        query +
        "&access_to=" +
        JSON.stringify(selctedUsers) +
        "&shared_with=" +
        JSON.stringify(selectedAccess),
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });
          //this.setState({rows:templateList,loader:false})
          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const getStyles = async () => {
    setTempLoader(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    var token = data.token;

    await fetch(
      GlobalApi +
        "/Template/get_template_report_details?template_id=" +
        temp_id,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (mainRes) => {
        console.log("mainRes____________________", mainRes);

        await fetch(GlobalApi + "/Admin/get_all_report_template", {
          method: "GET",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("styleData____________________", res);
            let styleData = [];
            if (res.status === "Success") {
              res.data.map((item) => {
                let sorted = JSON.parse(item.themes);
                item.themes = sorted;
                styleData.push(item);
              });
              console.log("styleData____________________", styleData);
              setStylesData(styleData);

              res.data.map((item) => {
                if (item.id == mainRes.data.report_template_id) {
                  setValue(parseInt(item.position) - 1);
                  item.themes.map((item, index) => {
                    if (item == mainRes.data.report_theme) {
                      setSelectedTheme(index);
                    }
                  });
                }
              });
            }
          })
          .catch((err) => {
            console.log(err, "error");
          });
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const changeReportStyle = (report_template_id, report_template_image) => {
    console.log("report_template_id", report_template_id);
    console.log("report_template_image", report_template_image);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var token = data.token;

    fetch(GlobalApi + "/Template/set_report_against_template", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        report_template_id: report_template_id,
        report_template_image: report_template_image,
        report_template_theme: stylesData[value].themes[selectedTheme],
        template_id: temp_id,
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.msg == "success") {
          swal(
            t("Success"),
            t("Report style has been changed successfully"),
            "success"
          );
          getStyles();
        }
        console.log("response>>>>>>>>>>", res);
      });
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          minHeight: "85vh",
          padding: "10px 30px",
          overflow: "hidden",
          backgroundColor: "#eaf7fe",
        }}
      >
        {/* ================================== Top Search and filter bar ========================= */}

        {/* ================================== Recently Created Templates  ========================= */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          className="shadow"
          style={{
            backgroundColor: "white",
            padding: "5px 0px",
            borderRadius: "5px",
            marginTop: "10px",
            overflowY: "hidden",
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              padding: "5px 20px",
              borderBottomWidth: "1px",
              borderBottomStyle: "solid",
              borderBottomColor: Colors.globalColor4,
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <p
                  className="label2"
                  style={{
                    marginBottom: 5,
                    fontSize: 14,
                    marginTop: 7,
                    color: Colors.globalColor8,
                    textTransform: "uppercase",
                  }}
                >
                  {t("Edit Report Template")}
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              padding: "5px 20px",
              borderBottomWidth: "1px",
              borderBottomStyle: "solid",
              borderBottomColor: Colors.globalColor4,
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <div>
                <p
                  className="label2"
                  style={{
                    marginBottom: 5,
                    fontSize: 12,
                    marginTop: 7,
                    color: "grey",
                  }}
                >
                  {company.company_name} {">"} {template_name}
                </p>
              </div>
            </div>
          </Grid>
          <div
            className="scrollbarShow2"
            style={{ overflowY: "scroll", overflowX:'hidden', width: "100%" }}
          >
            {window.innerWidth > 700 && (
              <Grid
                className="scrollbarShow2"
                container
                justifyContent="center"
                spacing={1}
                style={{ padding: "20px", maxHeight: "70vh" }}
              >
                <AppBar
                  className="reportAppBar"
                  position="center"
                  color="warning"
                >
                  <Tabs
                    className="reportTabs"
                    style={{ backgroundColor: "#f2f2f2" }}
                    value={value}
                    onChange={handleChange}
                    centered
                    scrollButtons="on"
                    indicatorColor="primary"
                    textColor="green"
                    aria-label="scrollable force tabs example"
                  >
                    {stylesData.map((item, index) => {
                      return (
                        <Tab
                          className="hero"
                          label={
                            <p
                              className="label2"
                              style={{
                                marginBottom: 5,
                                fontSize: 12,
                                marginTop: 7,
                                textAlign: "left",
                              }}
                            >
                              {item.report_template_type}
                            </p>
                          }
                          icon={
                            item.report_template_key ? (
                              <img
                                src={
                                  "https://server.uraudits.com/view?Key=" +
                                  item.report_template_key
                                }
                                className="ReportStyleImage"
                                width={"120px"}
                                height={"150px"}
                                style={{ border: "2px solid white" }}
                              />
                            ) : (
                              <img
                                src={placeholder}
                                className="ReportStyleImage"
                                width={"120px"}
                                height={"150px"}
                                style={{ border: "2px solid white" }}
                              />
                            )
                          }
                          {...a11yProps(index)}
                        />
                      );
                    })}
                  </Tabs>
                </AppBar>
                {stylesData.map((item, index) => {
                  console.log(
                    "CURRENT ITEM________________________________________________",
                    item
                  );
                  return (
                    <TabPanel
                      value={value}
                      index={index}
                      style={{ width: "100%" }}
                    >
                      <Grid
                        xs={12}
                        container
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ width: "100%" }}
                      >
                        <Grid item xs={12} md={6} lg={6}>
                          <Grid xs={12} container>
                            <Grid item xs={12} md={3} lg={3}>
                              <div
                                style={{
                                  padding: "20px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  height: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                {item.themes ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.themes[selectedTheme]
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                                <br />
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={12} md={9} lg={9}>
                              <div style={{ padding: "20px" }}>
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                          <div style={{ padding: "0px 30px 30px" }}>
                            <p
                              className="label2"
                              style={{ fontSize: 20, marginBottom: 5 }}
                            >
                              {item.report_template_type}: Trend Report
                            </p>
                            <p
                              className="label3"
                              style={{
                                fontSize: 14,
                                marginBottom: 10,
                                textAlign: "justify",
                                fontWeight: "normal",
                                color: "grey",
                              }}
                            >
                              {item.description}
                            </p>
                            {/* <List>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                2 summary charts: comparison with up to 5 past audit scores, a performance by category/area
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Includes past responses for each question
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Actual vs target, points and percentage, score range (e.g. Pass {">"} 70% and Fail {"<"}70%)
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Dark blue/grey color palette
                              </p>
                            </ListItem>
    
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Available in all reports: photos, comments, actions, signatures, map, report summary with 2 custom logos
                              </p>
                            </ListItem>
                          </List> */}
                            {/* <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                            Settings
                          </p>
                          <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                          <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                            Top Left Logo
                          </p>
    
                          <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                            <>
                              <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                              <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                                Upload
                              </p>
                            </>
                          </div> */}
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 20,
                                width: "100%",
                                marginBottom: 10,
                              }}
                            />
                            <p
                              className="label2"
                              style={{ fontSize: 16, marginBottom: 5 }}
                            >
                              {t("Select Cover Page")}
                            </p>
                            <div
                              style={{
                                padding: "0px",
                                display: "flex",
                                justifyContent: "flex-start",
                                overflowX: "scroll",
                                overflowY: "hidden"
                                
                              }}
                              className="scrollbarShow2"
                            >
                              {item.themes.length > 0 &&
                                item.themes.map((subItem, subIndex) => {
                                  return (
                                    <div
                                      onClick={() => setSelectedTheme(subIndex)}
                                      style={{
                                        padding: "5px",
                                        margin: "5px",
                                        display: "inline-flex",
                                        backgroundColor:
                                          selectedTheme === subIndex
                                            ? Colors.globalColor8
                                            : "#dadada",
                                      }}
                                    >
                                      <img
                                        src={
                                          "https://server.uraudits.com/view?Key=" +
                                          subItem
                                        }
                                        className="ReportStyleImage"
                                        width={"60px"}
                                        style={{
                                          border: "2px solid white",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 10,
                                width: "100%",
                                marginBottom: 20,
                              }}
                            />
                            <Button
                              className="addBtn"
                              variant="contained"
                              style={{ backgroundColor: Colors.globalColor8 }}
                              onClick={() =>
                                changeReportStyle(
                                  item.id,
                                  item.report_template_key
                                )
                              }
                            >
                              {t("Save")}
                            </Button>
                            &emsp;
                            <Button
                              variant="contained"
                              className="cancelBtn"
                              onClick={() => handleCancel()}
                            >
                              {t("Cancel")}
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </TabPanel>
                  );
                })}

                {/* <TabPanel value={value} index={0} style={{ width: "100%" }}>
                <Grid xs={12} container justifyContent="center" alignItems="flex-start" spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <img src={placeholder} className="ReportStyleImage" width={"100%"} style={{ border: "2px solid white" }} />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <p className="label2" style={{ fontSize: 20, marginBottom: 5 }}>
                        Style 1: Trend Report
                      </p>

                      <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                        Detailed report with historical scores, to benchmark site performance over time and get insight into recurrent failures. Recommended for: weekly/monthly audits, regular visits, quality assessments etc
                      </p>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                            2 summary charts: comparison with up to 5 past audit scores, a performance by category/area
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                            Includes past responses for each question
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                            Actual vs target, points and percentage, score range (e.g. Pass {">"} 70% and Fail {"<"}70%)
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                            Dark blue/grey color palette
                          </p>
                        </ListItem>

                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                            Available in all reports: photos, comments, actions, signatures, map, report summary with 2 custom logos
                          </p>
                        </ListItem>
                      </List>

                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Settings
                      </p>
                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Top Left Logo
                      </p>

                      <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                        <>
                          <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                          <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                            Upload
                          </p>
                        </>
                      </div>

                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 20, width: "100%", marginBottom: 20 }} />
                      <Button  size="large" variant="contained" style={{backgroundColor:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: "white", marginTop: "0px" }}>
                            Save
                          </p>
                      </Button>
                      &emsp;

                      <Button  size="large" variant="outlined" style={{borderColor:Colors.globalColor8, color:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: Colors.globalColor8, marginTop: "0px" }}>
                            Cancel
                          </p>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={1}>
              <Grid xs={12} container justifyContent="center" alignItems="flex-start" spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <img src={placeholder} className="ReportStyleImage" width={"100%"} style={{ border: "2px solid white" }} />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <p className="label2" style={{ fontSize: 20, marginBottom: 5 }}>
                      Style 2: Trend Report - Compact
                      </p>

                      <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                      Compact report with historical scores, to benchmark site performance over time. Displays questions in 2 columns for a compact viewing, ideal for checklist with hundreds of questions.
                      </p>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Scores with 2 summary charts; highlighting the trends along with category breakdown
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Does not includes past responses for questions
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Show points and percentages along with defined score ranges (e.g. Pass {">"} 70% and Fail {"<"}70%)
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Dark blue/grey color palette
                          </p>
                        </ListItem>

                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Features available in all reports: photos, comments, actions, signatures, map along with 2 brand logos
                          </p>
                        </ListItem>
                      </List>

                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Settings
                      </p>
                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Top Left Logo
                      </p>

                      <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                        <>
                          <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                          <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                            Upload
                          </p>
                        </>
                      </div>

                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 20, width: "100%", marginBottom: 20 }} />
                      <Button  size="large" variant="contained" style={{backgroundColor:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: "white", marginTop: "0px" }}>
                            Save
                          </p>
                      </Button>
                      &emsp;

                      <Button  size="large" variant="outlined" style={{borderColor:Colors.globalColor8, color:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: Colors.globalColor8, marginTop: "0px" }}>
                            Cancel
                          </p>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={2}>
              <Grid xs={12} container justifyContent="center" alignItems="flex-start" spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <img src={placeholder} className="ReportStyleImage" width={"100%"} style={{ border: "2px solid white" }} />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <p className="label2" style={{ fontSize: 20, marginBottom: 5 }}>
                      Style 3: Professional Report
                      </p>

                      <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                      Detailed report with multiple charts breaking down scores over time, by response type or by category. Clean look with no past question responses with a lighter color palette. Very useful response type chart.
                      </p>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          2 summary charts: comparison with up to 5 past audit scores, a performance by category/area
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Yellow-grey color palette
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Does not includes past responses for questions
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Features available in all reports: photos, comments, actions, signatures, map along with 2 brand logos
                          </p>
                        </ListItem>
                      </List>

                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Settings
                      </p>
                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Top Left Logo
                      </p>

                      <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                        <>
                          <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                          <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                            Upload
                          </p>
                        </>
                      </div>

                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 20, width: "100%", marginBottom: 20 }} />
                      <Button  size="large" variant="contained" style={{backgroundColor:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: "white", marginTop: "0px" }}>
                            Save
                          </p>
                      </Button>
                      &emsp;

                      <Button  size="large" variant="outlined" style={{borderColor:Colors.globalColor8, color:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: Colors.globalColor8, marginTop: "0px" }}>
                            Cancel
                          </p>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={3}>
              <Grid xs={12} container justifyContent="center" alignItems="flex-start" spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <img src={placeholder} className="ReportStyleImage" width={"100%"} style={{ border: "2px solid white" }} />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <p className="label2" style={{ fontSize: 20, marginBottom: 5 }}>
                      Style 4: Classic Report
                      </p>

                      <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                      Simple format with questions and answers in 2 columns, grouped by category. No scores, no history. Recommended for: snagging, capturing observation and pictures, one-off site visits, unstructured visits, incident reporting or for taking larger pictures.
                      </p>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Report with no scores. Suits all occasions.
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Simple flow of questions with colour responses
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Black & White color palette. Printer friendly
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Features available in all reports: photos, comments, actions, signatures, map along with 2 brand logos
                          </p>
                        </ListItem>
                      </List>

                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Settings
                      </p>
                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Top Left Logo
                      </p>

                      <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                        <>
                          <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                          <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                            Upload
                          </p>
                        </>
                      </div>

                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 20, width: "100%", marginBottom: 20 }} />
                      <Button  size="large" variant="contained" style={{backgroundColor:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: "white", marginTop: "0px" }}>
                            Save
                          </p>
                      </Button>
                      &emsp;

                      <Button  size="large" variant="outlined" style={{borderColor:Colors.globalColor8, color:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: Colors.globalColor8, marginTop: "0px" }}>
                            Cancel
                          </p>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={4}>
              <Grid xs={12} container justifyContent="center" alignItems="flex-start" spacing={2} style={{ width: "100%" }}>
                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <img src={placeholder} className="ReportStyleImage" width={"100%"} style={{ border: "2px solid white" }} />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <div style={{ padding: "30px" }}>
                      <p className="label2" style={{ fontSize: 20, marginBottom: 5 }}>
                      Style 5: Classic Report - Single Column
                      </p>

                      <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                      The same as “Classic Report”, but the responses are displayed immediately below the questions (rather than in a separate column). Particularly useful for lengthy texts. Simple format with questions and answers grouped by category. No scores, no history.
                      </p>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Responses displayed immediately below the question.
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Report with no scores. Suits all occasions.
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Simple flow of questions with colour responses
                          </p>
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Black & White color palette. Printer friendly
                          </p>
                        </ListItem>

                        <ListItem>
                          <ListItemIcon>
                            <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                          </ListItemIcon>
                          <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                          Features available in all reports: photos, comments, actions, signatures, map along with 2 brand logos
                          </p>
                        </ListItem>
                      </List>

                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Settings
                      </p>
                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                      <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                        Top Left Logo
                      </p>

                      <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                        <>
                          <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                          <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                            Upload
                          </p>
                        </>
                      </div>

                      <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 20, width: "100%", marginBottom: 20 }} />
                      <Button  size="large" variant="contained" style={{backgroundColor:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: "white", marginTop: "0px" }}>
                            Save
                          </p>
                      </Button>
                      &emsp;

                      <Button  size="large" variant="outlined" style={{borderColor:Colors.globalColor8, color:Colors.globalColor8}}>
                      <p className="label2" style={{ fontSize: 12, color: Colors.globalColor8, marginTop: "0px" }}>
                            Cancel
                          </p>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel> */}
              </Grid>
            )}

            {window.innerWidth > 500 && window.innerWidth <= 700 && (
              <Grid
                className="scrollHidden"
                container
                justifyContent="center"
                spacing={1}
                style={{ padding: "20px" }}
              >
                <AppBar
                className="reportAppBar"
                position="center"
                color="warning"
                style={{width:'100%', overflow:"auto"}}
               
              >
                <Tabs
                  className="reportTabs"
                  style={{backgroundColor:'#f2f2f2'}}
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
                  textColor="green"
                >
                  {stylesData.map((item, index) => {
              
                    return (
                      <Tab
                        className="hero"
                        label={
                          <p
                            className="label2"
                            style={{
                              marginBottom: 5,
                              fontSize: 12,
                              marginTop: 7,
                              textAlign: "left",
                            }}
                          >
                            {item.report_template_type}
                          </p>
                        }
                        icon={
                          item.report_template_key ? (
                            <LazyLoadImage
                            alt={"Report Style"}
                            height={"150px"}
                            src={"https://server.uraudits.com/view?Key=" + item.report_template_key} // use normal <img> attributes as props
                            width={"120px"} />
                            // <img
                            // src={"https://server.uraudits.com/view?Key=" +
                            // item.report_template_key}
                            //   alt="test"
                            //   loading="lazy"
                            //   className="ReportStyleImage"
                            //   width={"120px"}
                            //   height={"150px"}
                            //   style={{ border: "2px solid white" }}
                            // />
                          ) : (
                            <img
                              src={placeholder}
                              alt="test"
                              loading="lazy"
                              className="ReportStyleImage"
                              width={"50px"}
                              height={"100px"}
                              style={{ border: "2px solid white" }}
                            />
                          )
                        //   <img
                        //   src={placeholder}
                        //   alt="test"
                        //   className="ReportStyleImage"
                        //   width={"120px"}
                        //   height={"150px"}
                        //   style={{ border: "2px solid white" }}
                        // />
                        }
                        {...a11yProps(index)}
                      />
                    );
                  })}
                </Tabs>
              </AppBar>
                  {stylesData.map((item, index) => {
                  console.log(
                    "CURRENT ITEM________________________________________________",
                    item
                  );
                  return (
                    <TabPanel
                      value={value}
                      index={index}
                      style={{ width: "100%" }}
                    >
                      <Grid
                        xs={12}
                        container
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ width: "100%" }}
                      >
                        <Grid item xs={12} md={6} lg={6}>
                          <Grid xs={12} container>
                            <Grid item xs={12} sm={4} lg={3}>
                              <div
                                style={{
                                  padding: "20px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  height: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                {item.themes ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.themes[selectedTheme]
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                                <br />
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={8} lg={9}>
                              <div style={{ padding: "20px" }}>
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                          <div style={{ padding: "0px 30px 30px" }}>
                            <p
                              className="label2"
                              style={{ fontSize: 20, marginBottom: 5 }}
                            >
                              {item.report_template_type}: Trend Report
                            </p>
                            <p
                              className="label3"
                              style={{
                                fontSize: 14,
                                marginBottom: 10,
                                textAlign: "justify",
                                fontWeight: "normal",
                                color: "grey",
                              }}
                            >
                              {item.description}
                            </p>
                            {/* <List>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                2 summary charts: comparison with up to 5 past audit scores, a performance by category/area
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Includes past responses for each question
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Actual vs target, points and percentage, score range (e.g. Pass {">"} 70% and Fail {"<"}70%)
                              </p>
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Dark blue/grey color palette
                              </p>
                            </ListItem>
    
                            <ListItem>
                              <ListItemIcon>
                                <EjectIcon style={{ transform: "rotate(90deg)", color: Colors.globalColor8 }} />
                              </ListItemIcon>
                              <p className="label3" style={{ fontSize: 14, marginBottom: 10, textAlign: "justify", fontWeight: "normal", color: "grey" }}>
                                Available in all reports: photos, comments, actions, signatures, map, report summary with 2 custom logos
                              </p>
                            </ListItem>
                          </List> */}
                            {/* <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                            Settings
                          </p>
                          <hr style={{ borderTop: "2px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 10 }} />
                          <p className="label2" style={{ fontSize: 14, marginBottom: 5 }}>
                            Top Left Logo
                          </p>
    
                          <div style={{ width: "80px", padding: "5px", textAlign: "center", justifyContent: "center", height: "100px", display: "flex", flexDirection: "column", borderRadius: "5px", backgroundColor: Colors.globalColor8 }}>
                            <>
                              <AddIcon style={{ transform: "rotate(90deg)", color: "white", textAlign: "center", width: "100%" }} />
                              <p className="label2" style={{ fontSize: 14, color: "white", marginTop: "0px" }}>
                                Upload
                              </p>
                            </>
                          </div> */}
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 20,
                                width: "100%",
                                marginBottom: 10,
                              }}
                            />
                            <p
                              className="label2"
                              style={{ fontSize: 16, marginBottom: 5 }}
                            >
                              Select Cover Page
                            </p>
                            <div
                              style={{
                                padding: "0px",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              {item.themes.length > 0 &&
                                item.themes.map((subItem, subIndex) => {
                                  return (
                                    <div
                                      onClick={() => setSelectedTheme(subIndex)}
                                      style={{
                                        padding: "5px",
                                        margin: "5px",
                                        display: "inline-flex",
                                        backgroundColor:
                                          selectedTheme === subIndex
                                            ? Colors.globalColor8
                                            : "#dadada",
                                      }}
                                    >
                                      <img
                                        src={
                                          "https://server.uraudits.com/view?Key=" +
                                          subItem
                                        }
                                        className="ReportStyleImage"
                                        width={"60px"}
                                        style={{
                                          border: "2px solid white",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 10,
                                width: "100%",
                                marginBottom: 20,
                              }}
                            />
                            <Button
                              className="addBtn"
                              variant="contained"
                              style={{ backgroundColor: Colors.globalColor8 }}
                              onClick={() =>
                                changeReportStyle(
                                  item.id,
                                  item.report_template_key
                                )
                              }
                            >
                              Save
                            </Button>
                            &emsp;
                            <Button
                              variant="contained"
                              className="cancelBtn"
                              onClick={() => handleCancel()}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </TabPanel>
                  );
                })}

              </Grid>
            )}

            {window.innerWidth <= 500 && (
              <Grid
                className="mobileBox"
                container
                justifyContent="center"
                spacing={1}
                style={{ padding: "20px", maxHeight: "70vh" }}
              >
                <AppBar
                  className="reportAppBar2"
                  position="center"
                  color="warning"
                  style={{ width: "100%", overflowX: "scroll", backgroundColor:"transparent" }}
                >
                  <Tabs
                    className="reportTabs2"
                    style={{ maxWidth: "400px",height:"200px"}}
                    value={value}
                    onChange={handleChange}
                    centered
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    textColor="green"
                  >
                    {stylesData.map((item, index) => {
                      return (
                        <Tab
                          className="hero"
                          label={
                            <p
                              className="label2"
                              style={{
                                marginBottom: 5,
                                fontSize: 12,
                                marginTop: 7,
                                textAlign: "left",
                              }}
                            >
                              {item.report_template_type}
                            </p>
                          }
                          icon={
                            item.report_template_key ? (
                              <img
                                src={
                                  "https://server.uraudits.com/view?Key=" +
                                  item.report_template_key
                                }
                                className="ReportStyleImage"
                                width={"100px"}
                                height={"120px"}
                                style={{
                                  border: "2px solid white",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <img
                                src={placeholder}
                                className="ReportStyleImage"
                                width={"100px"}
                                height={"120px"}
                                style={{ border: "2px solid white" }}
                              />
                            )
                          }
                          {...a11yProps(index)}
                        />
                      );
                    })}
                  </Tabs>
                </AppBar>
                {stylesData.map((item, index) => {
                  console.log(
                    "CURRENT ITEM________________________________________________",
                    item
                  );
                  return (
                    <TabPanel
                      value={value}
                      index={index}
                      style={{ width: "100%" }}
                    >
                      <Grid
                        xs={12}
                        container
                        justifyContent="center"
                        alignItems="flex-start"
                        style={{ width: "100%" }}
                      >
                        <Grid item xs={12} md={6} lg={6}>
                        <Grid xs={12} container>
                            <Grid item xs={4}>
                              <div
                                style={{
                                  padding: "5px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  height: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                {item.themes ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.themes[selectedTheme]
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                      marginBottom:'10px'
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                      marginBottom:'10px'
                                    }}
                                  />
                                )}
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={8}>
                              <div style={{ padding: "5px" }}>
                                {item.report_template_key ? (
                                  <img
                                    src={
                                      "https://server.uraudits.com/view?Key=" +
                                      item.report_template_key
                                    }
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={placeholder}
                                    className="ReportStyleImage"
                                    width={"100%"}
                                    style={{
                                      border: "2px solid #dadada",
                                    }}
                                  />
                                )}
                              </div>
                            </Grid>
                          </Grid>
                          {/* {item.position === "1" && (
                            <div
                              style={{
                                padding: "10px",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {themesArr.length > 0 &&
                                themesArr.map((item, index) => {
                                  return (
                                    <div
                                      onClick={() => setSelectedTheme(index)}
                                      style={{
                                        padding: "5px",
                                        margin: "5px",
                                        display: "inline-flex",
                                        backgroundColor:
                                          selectedTheme === index
                                            ? Colors.globalColor8
                                            : "#dadada",
                                      }}
                                    >
                                      <img
                                        src={
                                          "https://server.uraudits.com/view?Key=" +
                                          item
                                        }
                                        className="ReportStyleImage"
                                        width={"40px"}
                                        style={{
                                          border: "2px solid white",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                          )} */}
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                          <div style={{ padding: "10px" }}>
                            <p
                              className="label2"
                              style={{ fontSize: 20, marginBottom: 5 }}
                            >
                              {item.report_template_type}: Trend Report
                            </p>
                            <p
                              className="label3"
                              style={{
                                fontSize: 14,
                                marginBottom: 10,
                                textAlign: "justify",
                                fontWeight: "normal",
                                color: "grey",
                              }}
                            >
                              {item.description}
                            </p>
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 20,
                                width: "100%",
                                marginBottom: 10,
                              }}
                            />
                            <p
                              className="label2"
                              style={{ fontSize: 16, marginBottom: 5 }}
                            >
                              Select Cover Page
                            </p>
                            <div
                              style={{
                                padding: "0px",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              {item.themes.length > 0 &&
                                item.themes.map((subItem, subIndex) => {
                                  return (
                                    <div
                                      onClick={() => setSelectedTheme(subIndex)}
                                      style={{
                                        padding: "3px",
                                        margin: "3   px",
                                        display: "inline-flex",
                                        backgroundColor:
                                          selectedTheme === subIndex
                                            ? Colors.globalColor8
                                            : "#dadada",
                                      }}
                                    >
                                      <img
                                        src={
                                          "https://server.uraudits.com/view?Key=" +
                                          subItem
                                        }
                                        className="ReportStyleImage"
                                        width={"50px"}
                                        style={{
                                          border: "2px solid white",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                            <hr
                              style={{
                                borderTop: "2px solid #dadada",
                                borderBottom: "none",
                                marginTop: 20,
                                width: "100%",
                                marginBottom: 20,
                              }}
                            />

                            <Button
                              className="addBtn"
                              variant="contained"
                              style={{
                                width: "100%",
                                backgroundColor: Colors.globalColor8,
                                margin: "auto",
                              }}
                              onClick={() =>
                                changeReportStyle(
                                  item.id,
                                  item.report_template_key
                                )
                              }
                            >
                              Save
                            </Button>
                            <br />

                            <Button
                              variant="contained"
                              style={{ width: "100%", marginTop: "10px" }}
                              className="cancelBtn2"
                              onClick={() => handleCancel()}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </TabPanel>
                  );
                })}
              </Grid>
            )}
          </div>
        </Grid>
      </div>
    </>
  );
}

export default TemplateReportStyle;
